export const applications = [
  'maintainit',
  'combi',
  'model_production',
  '07_03_01_materials_rd',
  'qm_sampling',
  'qualitymanagement',
  'truvant_pl_qa',
  'truvant_pl',
  'moulding',
  'truvant_pl_dev',
  'air_external',
  'emma',
  'sealing',
  '07_02_03_packing_platform',
  '07_04_03_packing_technology_rd',
] as const;

export type Application = (typeof applications)[number];
